export enum AvailableVehicleCategory {
  CAR = 'CAR',
  TRUCK = 'TRUCK',
  DELIVERY = 'DELIVERY',
  TRAILERS = 'TRAILERS',
  BUS = 'BUS',
  MOTORCYCLE = 'MOTORCYCLE',
  CONSTRUCTION_VEHICLE = 'CONSTRUCTION_VEHICLE',
  AGRICULTURAL_VEHICLE = 'AGRICULTURAL_VEHICLE',
  OTHER = 'OTHER'
}
